<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Serviços em Produção</h1>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por cliente..." [(ngModel)]="searchTerm" (keyup.enter)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Buscar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID Controle</th>
          <th scope="col">ID Venda</th>
          <th scope="col">Cliente</th>
          <th scope="col">Data Fechamento</th>
          <th scope="col">Status Produção</th>
          <th scope="col">Previsão Entrega</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let controle of paginatedControles">
          <th scope="row">{{ controle.idControle }}</th>
          <td>{{ controle.idVenda }}</td>
          <td>{{ controle.nomeCliente }}</td>
          <td>{{ controle.dataFechamentoVenda | date:'dd/MM/yyyy' }}</td>
          <td>{{ controle.statusProducao }}</td>
          <td>{{ controle.previsaoEntrega | date:'dd/MM/yyyy HH:mm' }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-info btn-sm" (click)="verDetalhes(controle.idControle)">Detalhes</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(1)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages)">Última</a>
      </li>
    </ul>
  </nav>
</div>